import { atom } from "recoil";

export const isInvoiceBarcodeState = atom({
  key: "isInvoiceBarcodeState",
  default: false,
});
